function populateProvinces(countrySelect, provinceSelect, selectedProvince) {
  const selectedOption = countrySelect.options[countrySelect.selectedIndex];
  const provincesJson = selectedOption ? selectedOption.getAttribute('data-provinces') || '[]' : '[]';
  let provinces = [];
  try {
    provinces = JSON.parse(provincesJson);
  } catch (e) {
    provinces = [];
  }

  const wrapper = provinceSelect.closest('[data-province-wrapper]');
  provinceSelect.innerHTML = '';

  if (provinces.length === 0) {
    if (wrapper) wrapper.hidden = true;
    return;
  }

  if (wrapper) wrapper.hidden = false;
  provinces.forEach(([value, label]) => {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = label;
    if (value === selectedProvince) option.selected = true;
    provinceSelect.appendChild(option);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-country-select]').forEach((countrySelect) => {
    const form = countrySelect.closest('form');
    if (!form) return;
    const provinceSelect = form.querySelector('[data-province-select]');
    if (!provinceSelect) return;

    if (countrySelect.dataset.default) {
      countrySelect.value = countrySelect.dataset.default;
    }

    const selectedProvince = provinceSelect.dataset.selected || '';
    populateProvinces(countrySelect, provinceSelect, selectedProvince);
    countrySelect.addEventListener('change', () => populateProvinces(countrySelect, provinceSelect, ''));
  });
});
